import { CardContent, Typography } from '@mui/material';
import { Card } from '@mui/material';
import { Grid } from '@mui/material';
import React from 'react';

interface CardSummaryProps {
  bottomText: string;
  value: string | number;
}

const CardSummary = (props: CardSummaryProps) => {
  const { bottomText, value } = props;
  return (
    <Grid item xs={12} sm={6} md={4}>
      <Card
        sx={{
          height: '100%',
          background: '#f8f9fa',
          '&:hover': {
            transform: 'translateY(-4px)',
            transition: 'transform 0.3s ease',
          },
        }}
      >
        <CardContent sx={{ textAlign: 'center', p: 2 }}>
          <Typography variant="h4" fontWeight={700} sx={{ mb: 1 }}>
            {value}
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.9 }}>
            {bottomText}
          </Typography>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default CardSummary;
